import { createSelector } from "reselect"
import { get } from "lodash"
import { getCurrentPerformance } from "./performance"
import { getDisplayCategories } from "./data"
import { getFactorCategoryId, getCategories } from "./items"
import { computeSelectedOption } from "helpers/analyze"
import { ATTRIBUTION_COLORS } from "helpers/analyzeConstants"

const EMPTY_ARRAY = []

export const getOptions = createSelector(
  [getCurrentPerformance, getCategories, getDisplayCategories],
  (current, categories, displayCategories) => {
    if (current) {
      const options = [{
        id: "total",
        color: ATTRIBUTION_COLORS.TOTAL,
        label: "Total",
        value: current.total,
      }, {
        id: "factors",
        color: ATTRIBUTION_COLORS.FACTOR,
        label: "Factors",
        value: current.factorsTotal,
      },
      ...categories
        .filter(category => !category.singleFactor)
        .map(category => {
          if (displayCategories.indexOf(category.id) === -1) return null

          const field = `categories.${category.id}`
          const value = get(current, field)

          return { value, ...category }
        }),
      ]

      // filter out options for which there's no value
      return options.filter(option => option && !Number.isNaN(option.value))
    } else {
      return EMPTY_ARRAY
    }
  },
)

export const getSelectedOption = createSelector(
  [getOptions, getFactorCategoryId],
  computeSelectedOption,
)
